<template>
    <div class="company_imgs">
        <div class="image-container" v-for="v in imgs" :key="v.id">
            <el-image style="width: 100%; height: 100%;" :src="v.contentImg[0]" fit="contain" />
            <div class="dec">{{ v.contentTitle }}</div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { getContentList } from '@/utils/api';

const imgs = ref([])

onMounted(() => {
    getInfo()
})

const getInfo = async () => {
    const data = await getContentList({ categoryId: '1893832330626265090' });
    if (data.rows?.length) {
        const result = data.rows.map(v => ({
            contentImg: v.contentImg ? JSON.parse(v.contentImg).map(img => process.env.VUE_APP_FILE_URL + img.url) : '',
            contentTitle: v.contentTitle,
            id: v.id
        }));

        console.log(result);
        
        return imgs.value = result
    }
    return imgs.value = []

}
</script>

<style lang="less" scoped>
.company_imgs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    // margin: 0 calc(8 * var(--groot-ui-rpx)) calc(20 * var(--groot-ui-rpx));
}

.image-container {
    width: calc(25% - calc(16 * var(--groot-ui-rpx)));
    height: calc(270 * var(--groot-ui-rpx));
    margin: calc(8 * var(--groot-ui-rpx)) calc(8 * var(--groot-ui-rpx)) calc(60 * var(--groot-ui-rpx));
    background: #f8f8f8;
}

.dec {
    line-height: calc(50 * var(--groot-ui-rpx));
    font-size: calc(16 * var(--groot-ui-rpx)) ;
}
</style>
